module.exports = __webpack_public_path__ + "static/media/adressPointerOrange.61095189.svg";